import React, { PropTypes, PureComponent } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';
import messages from './i18n';
import { BackArrow } from '../shared';
import styles from './styles.scss';

const appleBadge = require('./app-landing-app-store-badge.png');
const androidBadge = require('./app-landing-play-store-badge.png');
const appScreen = require('./app-landing-roster.png');

const appleURL = 'https://my.tanda.co/profile/app_store?platform=iPhone&tracking_key=tc-employee-app.apple-store.app-landing';
const androidURL = 'https://my.tanda.co/profile/app_store?platform=android&tracking_key=tc-employee-app.google-play-store.app-landing';

export class SignUpEmployee extends PureComponent {
  static propTypes = {
    signUpSetSteps: PropTypes.func,
  };

  static iosLink() {
    if (window.platform === 'ios' || !window.platform) {
      return (
        <a href={appleURL}>
          <img className={styles.download} src={appleBadge} alt="process" />
        </a>
      );
    }
    return null;
  }

  static androidLink() {
    if (window.platform === 'android' || !window.platform) {
      return (
        <a href={androidURL}>
          <img className={styles.download} src={androidBadge} alt="process" />
        </a>
      );
    }
    return null;
  }

  render() {
    return (
      <div
        className={cn(styles.view)}
      >
        <BackArrow
          styles="backArrowPositioning"
          destination="/user"
        />
        <div className={styles.layout}>
          <div className={styles.container}>
            <div className={styles.caption}>
              <h2><FormattedMessage {...messages.title_variation} /></h2>
              <p><FormattedMessage {...messages.subtitle_variation} /></p>
              <div className={styles.downloadContainer}>
                {SignUpEmployee.androidLink()}
                {SignUpEmployee.iosLink()}
              </div>
              <img
                className={styles.image}
                src={appScreen}
                alt="App landing roster"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(SignUpEmployee);



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_employee/index.jsx